import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShift2 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zM25 13l-5 5h4v13a1 1 0 1 0 2 0V18h4l-5-5zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z" />
    </svg>
);
export default SvgShift2;
